// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'LinkedIn';

interface LinkedInProps {
  className?: string;
}

export function LinkedInFilled({ className }: LinkedInProps) {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM8.0625 9.1875H5.25V18.75H8.0625V9.1875ZM6.63206 8.0625H6.64781C7.51969 8.0625 8.0625 7.43644 8.0625 6.65569C8.04675 5.8575 7.51969 5.25 6.66412 5.25C5.80969 5.25 5.25 5.8575 5.25 6.65569C5.25 7.437 5.79281 8.0625 6.63206 8.0625ZM15.9375 18.75H18.75L18.7494 13.2791C18.7494 10.4531 17.2403 9.1875 15.2276 9.1875C13.6031 9.1875 12.9681 10.0312 12.5625 10.659V9.1875H9.75V18.75H12.5625V13.6875C12.5625 13.6406 12.5618 13.5858 12.561 13.5262C12.5573 13.2367 12.5521 12.8343 12.6193 12.6711C12.8409 12.1209 13.2977 11.5517 14.142 11.5517C15.2484 11.5517 15.9375 12.3954 15.9375 13.6318V18.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LinkedIn({ className }: LinkedInProps) {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{TITLE}</title>
      <path
        d="M7.13955 5.90917C6.96055 6.0806 6.74824 6.21341 6.51578 6.29937C6.28332 6.38533 6.03568 6.42261 5.78822 6.40888C5.54947 6.42029 5.31096 6.38174 5.08797 6.29569C4.86497 6.20965 4.66239 6.078 4.49319 5.90917C4.33413 5.7507 4.20855 5.56188 4.12392 5.35392C4.03928 5.14595 3.99732 4.9231 4.00052 4.6986C3.99484 4.47377 4.03567 4.25019 4.12045 4.04187C4.20523 3.83356 4.33213 3.64501 4.49319 3.48803C4.66979 3.32232 4.87798 3.1939 5.10532 3.11046C5.33267 3.02702 5.5745 2.99027 5.81637 3.0024C6.05509 2.98987 6.29384 3.02651 6.51782 3.11005C6.74179 3.19359 6.94622 3.32224 7.11843 3.48803C7.43729 3.81162 7.62099 4.24445 7.63222 4.6986C7.63582 4.92316 7.59404 5.14613 7.50939 5.35414C7.42473 5.56216 7.29893 5.75094 7.13955 5.90917V5.90917ZM4.08498 7.76724H7.51961V18.7679H4.08498V7.76724ZM9.52549 9.38602C9.52549 8.8042 9.50437 8.26461 9.46215 7.76724H12.4323L12.5941 9.30157H12.6575C12.9826 8.84796 13.3824 8.45289 13.8399 8.13323C14.4924 7.6923 15.2704 7.47497 16.0569 7.51387C16.5976 7.51311 17.1332 7.61832 17.6335 7.82355C18.1053 8.01653 18.5267 8.31509 18.8652 8.69628C19.2391 9.12775 19.5216 9.63055 19.6957 10.1743C19.9124 10.8566 20.0147 11.5701 19.9983 12.2858V18.782H16.5707V12.6658C16.5974 12.0682 16.4611 11.4747 16.1766 10.9485C16.0381 10.724 15.8392 10.5429 15.6028 10.426C15.3664 10.309 15.1018 10.2608 14.8393 10.2869C14.4213 10.2654 14.0116 10.4095 13.6991 10.6881C13.4306 10.9308 13.2211 11.2317 13.0868 11.5679C13.039 11.6918 13.0105 11.8224 13.0023 11.955V18.7609H9.56068V11.2793C9.56068 10.5896 9.54895 9.95846 9.52549 9.38602V9.38602Z"
        fill="currentColor"
      />
    </svg>
  );
}
